/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import { updateTagByImageId } from '../../../api';
import PropTypes from 'prop-types';
import LabelStudio from '@heartexlabs/label-studio';
import '@heartexlabs/label-studio/build/static/css/main.css';

// eslint-disable react/prop-types
function LabelStudioUI({ imageId, imageLocation, taxonomy, boundingBoxData }) {
    const [updateStatus, setUpdateStatus] = useState(null);

    const generateLabelConfig = (taxonomy) => {
        let labelConfig = `
        <View>
            <RectangleLabels name="tag" toName="img">
                <Label value="Litter"/>
            </RectangleLabels>
            <Image name="img" value="$image" width="400px" maxWidth="600" />
            <View visibleWhen="region-selected">
                <Header value="Type in a tag and press Enter"/>
                <TextArea name="tags" toName="img" />
            </View>
        </View>
        `;

        // TODO: append taxonomy autocomplete data
        if (taxonomy) {
            labelConfig = `
                <View>
                    <RectangleLabels name="tag" toName="img">
                        <Label value="Litter"/>
                    </RectangleLabels>
                    <Image name="img" value="$image" width="400px" maxWidth="600" />
                    <View visibleWhen="region-selected">
                        <Header value="Type in a tag and press Enter"/>
                        <TextArea name="tags" toName="img" maxUsages="1" perRegion="true" visibleWhen="region-selected" />
                    </View>
                </View>
            `;
        }

        // escape ampersand for XML validation
        return labelConfig.replace(/&/g, '&amp;');
    };

    useEffect(() => {
        console.log('boundingBoxData', boundingBoxData);
        const labelConfig = generateLabelConfig(taxonomy);

        new LabelStudio('label-studio', {
            config: labelConfig,

            interfaces: [
                // "annotations:add-new",
                'annotations:delete',
                // "annotations:menu",
                // "annotations:history",
                // "annotations:current",
                // "annotations:tabs",
                // "annotations:view-all",
                'controls',
                'panel',
                // "predictions:menu",
                // "predictions:tabs",
                'side-column',
                'submit',
                // "infobar",
                'topbar',
                // "instruction",
                'update',
                // "ground-truth",
                'edit-history',
            ],

            user: {
                pk: 1,
                firstName: 'James',
                lastName: 'Dean',
            },

            task: {
                annotations: [
                    {
                        id: '1001',
                        result: [
                            // label studio example schema:
                            //
                            // {
                            //     from_name: 'tag',
                            //     id: 'Dx_aB91ISN',
                            //     source: '$image',
                            //     to_name: 'img',
                            //     type: 'rectanglelabels',
                            //     value: {
                            //         height: 10.458911419423693,
                            //         rectanglelabels: ['Litter'],
                            //         rotation: 0,
                            //         width: 12.4,
                            //         x: 50.8,
                            //         y: 5.869797225186766,
                            //     },
                            // },
                            ...boundingBoxData,
                        ],
                        was_cancelled: false,
                        // "ground_truth":false,
                        created_at: '2021-03-09T22:16:08.728353Z',
                        updated_at: '2021-03-09T22:16:08.728378Z',
                        lead_time: 4.288,
                        result_count: 0,
                        task: 1,
                        completed_by: 10,
                    },
                ],
                //   predictions: [{
                //     "created_ago": "3 hours",
                //     "model_version": "model 1",
                //     "result": [
                //         {
                //             "from_name": "tag",
                //             "id": "t5sp3TyXPo",
                //             "source": "$image",
                //             "to_name": "img",
                //             "type": "rectanglelabels",
                //             "value": {
                //                 "height": 11.612284069097889,
                //                 "rectanglelabels": [
                //                     "Litter"
                //                 ],
                //                 "rotation": 0,
                //                 "width": 39.6,
                //                 "x": 13.2,
                //                 "y": 34.702495201535505
                //             }
                //         }
                //     ]
                // },],
                id: 1,
                data: {
                    image: imageLocation,
                },
            },

            onLabelStudioLoad: function(LS) {
                var c = LS.annotationStore.addAnnotation({
                    userGenerate: true,
                });
                LS.annotationStore.selectAnnotation(c.id);
            },

            onSubmitAnnotation: async function(LS, annotation) {
                console.log('submit', annotation.serializeAnnotation());
            },

            onUpdateAnnotation: async function(LS, annotation) {
                const updateTags = async (imageId, updateData) => {
                    const result = await updateTagByImageId(
                        imageId,
                        updateData,
                    );

                    console.log('result', result);
                    if (result) {
                        setUpdateStatus({
                            status: 'success',
                            message: 'Update successful!',
                        });
                    } else {
                        setUpdateStatus({
                            status: 'error',
                            message: 'Unable to update tags',
                        });
                    }
                };

                const annotations = annotation.serializeAnnotation();
                console.log('update', annotations);

                const outputBoundingBoxes = annotations
                    .filter(
                        (annotation) =>
                            // filter annotations to only COMB changes
                            annotation.from_name === 'tags',
                    )
                    .map((annotation) => {
                        // reformat bounding boxes to same units as backend
                        const x = annotation.value.x / 100.0;
                        const y = annotation.value.y / 100.0;
                        const width = annotation.value.width / 100.0 + x;
                        const height = annotation.value.height / 100.0 + y;

                        return {
                            id: annotation.id,
                            box: [
                                [x, y],
                                [width, height],
                            ],
                            userTags: annotation.value.text,
                        };
                    });

                // call update endpoint
                if (outputBoundingBoxes && outputBoundingBoxes.length !== 0) {
                    const output = {
                        litters: outputBoundingBoxes,
                    };

                    console.log('output', output);
                    updateTags(imageId, output);
                }
            },
        });
    }, [imageLocation, taxonomy, boundingBoxData]);

    return (
        <>
            {updateStatus && (
                <Alert severity={updateStatus.status || 'error'}>
                    <AlertTitle>
                        {updateStatus.status === 'success'
                            ? 'Success'
                            : 'Error'}
                    </AlertTitle>
                    {updateStatus.message}
                </Alert>
            )}
            <div id="label-studio"></div>
        </>
    );
}

LabelStudioUI.propTypes = {
    imageId: PropTypes.number,
    imageLocation: PropTypes.string,
    taxonomy: PropTypes.object,
    boundingBoxData: PropTypes.arrayOf(PropTypes.object),
};

LabelStudioUI.defaultProps = {
    imageId: '',
    imageLocation: '',
    taxonomy: {
        object: [],
        material: [],
        brand: [],
    },
    boundingBoxData: [{}],
};

export default LabelStudioUI;
